import { createSelector } from "reselect"
import { get } from "lodash"
import { getModel } from "modules/research-topic-root/selectors"

const getRawSelectedModelId = state => get(state, "modules.smartTrade.modelId")

export const getModelId = createSelector(
  [getRawSelectedModelId, getModel],
  (selectedModelId, defaultModelId) => selectedModelId || defaultModelId,
)
